/**
 * Move one item without mutating the source array.
 *
 * Invalid moves return the original array so keyboard/accessibility actions at
 * either edge cannot accidentally mark a CV form as dirty.
 */
export function reorderListItem<T>(
  items: readonly T[],
  fromIndex: number,
  toIndex: number,
): T[] {
  if (
    fromIndex === toIndex ||
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= items.length ||
    toIndex >= items.length
  ) {
    return items as T[];
  }

  const next = [...items];
  const [moved] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, moved);
  return next;
}
